import {Api} from '../../../Api.js'

const RESOURCE = 'protractor'

export default {
    resource: RESOURCE,
    prefix: 'serevita/',
    all(query) {
        return Api().get(this.prefix + this.resource + '/all'  + (query ? query : '') )
    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    getStats(period, date = null) {

        if(date) {
            return Api().get(this.prefix + this.resource + '/stats?period=' + period + '&date=' + date);
        }

        return Api().get(this.prefix + this.resource + '/stats?period=' + period )
    }
}


// WEBPACK FOOTER //
// ./src/modules/serevita/protractor/ProtractorService.js